/**
 * Allowlist of valid TLDs (generic + common country codes).
 * Used for email validation to reject test/invalid domains.
 */
export const VALID_TLDS = [
  'com', 'org', 'net', 'edu', 'gov', 'mil', 'info', 'biz', 'name', 'pro',
  'coop', 'aero', 'museum', 'travel', 'int', 'io', 'co', 'ai', 'app', 'dev',
  'tech', 'health', 'care', 'healthcare', 'cloud', 'digital', 'online', 'site',
  'xyz', 'store', 'shop', 'blog', 'us', 'uk', 'ca', 'au', 'de', 'fr', 'in',
  'jp', 'cn', 'br', 'mx', 'es', 'it', 'nl', 'ru', 'kr', 'pl', 'se', 'no', 'fi',
  'dk', 'at', 'ch', 'be', 'ie', 'nz', 'sg', 'hk', 'my', 'th', 'ph', 'id', 'vn',
  'za', 'eg', 'sa', 'ae', 'il', 'tr', 'gr', 'pt', 'cz', 'ro', 'hu', 'cl', 'ar',
];

export const VALID_TLDS_SET = new Set<string>(VALID_TLDS);
